var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-grid m-grid--hor m-grid--root m-page"},[_c('topnav'),_vm._v(" "),_c('div',{staticClass:"m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body"},[_c('sidebar'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('footer-bar')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3c441a0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Dashboard.vue
// module id = null
// module chunks = 